module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedLightItalic.1964719.woff2";